import { Suspense, type ComponentProps, type FC } from 'react';
import { lazyWithRetry } from '../lib/lazyWithRetry';
import type { PdfReader as PdfReaderType } from './PdfReader';

/*
 * PDF ko'rgich (pdfjs-dist, ~400 KB) faqat PDF ochilganda yuklanadi.
 * Ilgari u asosiy faylning 29% ini tashkil qilardi — ya'ni har bir
 * o'quvchi PDF ochmasa ham uni har safar yuklab olardi.
 */
const Reader = lazyWithRetry(() =>
  import('./PdfReader').then((m) => m.PdfReader),
);

export const PdfReader: FC<ComponentProps<typeof PdfReaderType>> = (props) => (
  <Suspense
    fallback={
      <div className="skeleton skeleton-card" style={{ height: 320 }} />
    }
  >
    <Reader {...props} />
  </Suspense>
);
